import e_collapse from '@/components/designer/e-collapse'
import cpt_text from '@/components/element/cpt-text'
import cpt_total from '@/components/element/cpt-total'
import cpt_tree from '@/components/element/cpt-tree'
import cpt_carousel from '@/components/element/cpt-carousel'
import cpt_ninegrid from '@/components/element/cpt-ninegrid'
import cpt_button from '@/components/element/cpt-button'
import cpt_image from '@/components/element/cpt-image'
import cpt_chart_column from '@/components/echarts/cpt-chart-column'
import cpt_chart_pie from '@/components/echarts/cpt-chart-pie'
import cpt_dataV_border from '@/components/dataV/cpt-dataV-border'
// import cpt_dataV_scrollTable from '@/components/dataV/cpt-dataV-scrollTable'
import cpt_chart_map_gc from '@/components/echarts/cpt-chart-map-gc'
import cpt_chart_map_migrate from '@/components/echarts/cpt-chart-map-migrate'
import cpt_dataV_waterLevel from '@/components/dataV/cpt-dataV-waterLevel'
import cpt_dataV_decoration from '@/components/dataV/cpt-dataV-decoration'
import cpt_chart_line from '@/components/echarts/cpt-chart-line'
import cpt_dataV_percentPond from '@/components/dataV/cpt-dataV-percentPond'
import cpt_iframe from '@/components/element/cpt-iframe'
import cpt_chart_column_region from '@/components/echarts/cpt-chart-column-region'
import cpt_dataV_activeRing from '@/components/dataV/cpt-dataV-activeRing'
import cpt_chart_gauge from '@/components/echarts/cpt-chart-gauge'
import cpt_chart_scroll_list from '@/components/echarts/cpt-chart-scroll-list'
import cpt_g6_dom from '@/components/g6/cpt-g6-dom'
import cpt_threejs_dom from '@/components/three/cpt-threejs-dom'
import cpt_table from '@/components/element/cpt-table'
import cpt_datetime from '@/components/element/cpt-datetime'
import cpt_scroll_text from '@/components/element/cpt-scroll-text'
import cpt_video_player from '@/components/element/cpt-video-player'
// import cpt_live from '@/components/element/cpt-live'
import cpt_chart_progress_ring from '@/components/echarts/cpt-chart-progress-ring'
import cpt_tab from '@/components/element/cpt-tab'
import cpt_fullscreen from '@/components/element/cpt-fullscreen'
import cpt_checkbox from '@/components/element/cpt-checkbox'
import cpt_num from '@/components/element/cpt-num'
import cpt_chart_polycyclic from '@/components/echarts/cpt-chart-polycyclic'
import cpt_ring_pie from '@/components/echarts/cpt-ring-pie'
import cpt_icon_ring from '@/components/other/cpt-icon-ring'
import cpt_icon_quota from '@/components/element/cpt-icon-quota'
import cpt_scroll_table from '@/components/element/cpt-scroll-table'
import cpt_img_quota from '@/components/other/cpt-img-quota'
import cpt_img_quota_tips from '@/components/other/cpt-img-quota-tips'
import cpt_chart_radar from '@/components/echarts/cpt-chart-radar'
import cpt_chart_scatter from '@/components/echarts/cpt-chart-scatter'
import cpt_rect_num from '@/components/element/cpt-rect-num'
import cpt_chart_column_stack from '@/components/echarts/cpt-chart-column-stack'
import cpt_chart_funnel from '@/components/echarts/cpt-chart-funnel'
import cpt_weather from '@/components/element/cpt-weather'
import cpt_chart_candlestick from '@/components/echarts/cpt-chart-candlestick'
import cpt_chart_column_stereo from '@/components/echarts/cpt-chart-column-stereo'
import cpt_three_server_room from '@/components/three/server-room/cpt-three-server-room'
import cpt_input from '@/components/element/cpt-input'
import cpt_input_mobile from '@/components/mobile/cpt-input'
import cpt_select from '@/components/element/cpt-select'
import cpt_select_mobile from '@/components/mobile/cpt-select'
import cpt_date_picker from '@/components/element/cpt-date-picker'
import cpt_calendar from '@/components/element/cpt-calendar'
import cpt_date_picker_mobile from '@/components/mobile/cpt-date-picker'
import cpt_jumper from '@/components/element/cpt-jumper'
import cpt_audio from '@/components/element/cpt-audio'
import cpt_chart_map_3d from '@/components/echarts/cpt-chart-map-3d'
import cpt_chart_column_3d from '@/components/echarts/cpt-chart-column-3d'
import cpt_time_run from '@/components/element/cpt-time-run'
import cpt_indicator from '@/components/element/cpt-indicator'
import cpt_chart_line_multiple from '@/components/echarts/cpt-chart-line-multiple'
import cpt_chart_line_dual from '@/components/echarts/cpt-chart-line-dual'
import cpt_chart_map_3d_line from '@/components/echarts/cpt-chart-map-3d-line'
import cpt_chart_pie_3d from '@/components/echarts/cpt-chart-pie-3d'
import cpt_quota_progress from '@/components/element/cpt-quota-progress'
import cpt_link_card from '@/components/element/cpt-link-card'
import cpt_img_state from '@/components/element/cpt-img-state'
import cpt_navigator from '@/components/element/cpt-navigator'
import cpt_scroll_list from '@/components/element/cpt-scroll-list.vue'
import cpt_water_prop from '@/components/echarts/cpt-water-prop.vue'
import cpt_chart_rect_stack from '@/components/echarts/cpt-chart-rect-stack'
import cpt_chart_wordcloud from '@/components/echarts/cpt-chart-wordcloud.vue'
import cpt_chart_line_3d from '@/components/echarts/cpt-chart-line-3d.vue'
import cpt_page from '@/components/element/cpt-page.vue'
import cpt_combination_page from '@/components/element/cpt-combination-page'
import cpt_switch from '@/components/element/cpt-switch.vue'
import cpt_phone from '@/components/element/cpt-phone.vue'
import cpt_drawarea from '@/components/element/cpt-drawarea.vue'
import cpt_realtime_position from '@/components/element/cpt-realtime-position.vue'
import cpt_display_trail from '@/components/element/cpt-display-trail.vue'
import cpt_choose_place from '@/components/element/cpt-choose-place.vue'

// import cpt_tree_select from '@/components/element/cpt-tree-select.vue'
import cpt_password from '@/components/element/cpt-password.vue'
import cpt_badge from '@/components/element/cpt-badge.vue'
import cpt_map_navigator from '@/components/element/cpt-map-navigator.vue'
import cpt_amount from '@/components/element/cpt-amount.vue'
import cpt_number from '@/components/element/cpt-number.vue'
import cpt_phone_number from '@/components/element/cpt-phone-number.vue'
import cpt_scan from '@/components/element/cpt-scan.vue'
import cpt_radio from '@/components/element/cpt-radio.vue'
import cpt_time_picker from '@/components/element/cpt-time-picker.vue'
import cpt_input_search from '@/components/element/cpt-input-search.vue'
import cpt_suspension from '@/components/element/cpt-suspension.vue'
import cpt_qrcode from '@/components/element/cpt-qrcode.vue'
import cpt_textarea from '@/components/element/cpt-textarea.vue'
import cpt_iconfont from '@/components/element/cpt-iconfont.vue'
import cpt_richtxt from '@/components/element/cpt-richtxt.vue'
export default {
    e_collapse,
    cpt_dataV_border,cpt_text,cpt_total,cpt_tree,cpt_carousel,cpt_button,cpt_image,cpt_ninegrid,
    cpt_chart_column,cpt_chart_column_region,cpt_chart_pie,
    cpt_chart_map_gc,cpt_chart_map_migrate,
    cpt_dataV_waterLevel,cpt_dataV_decoration,cpt_chart_line,
    cpt_dataV_percentPond,cpt_iframe,
    cpt_dataV_activeRing,cpt_chart_gauge,cpt_chart_scroll_list,cpt_g6_dom,
    cpt_table,cpt_datetime,cpt_scroll_text,cpt_video_player,
    // cpt_live,
    cpt_chart_progress_ring,cpt_tab,cpt_fullscreen,cpt_checkbox,cpt_num,cpt_chart_polycyclic,
    cpt_ring_pie,cpt_icon_ring,cpt_icon_quota,cpt_scroll_table,
    cpt_img_quota,cpt_img_quota_tips,cpt_threejs_dom,
    cpt_chart_radar,cpt_chart_scatter,cpt_rect_num,cpt_chart_column_stack,
    cpt_chart_funnel,cpt_weather,cpt_chart_candlestick,cpt_chart_column_stereo,
    cpt_three_server_room,cpt_input,cpt_input_mobile,cpt_select,cpt_select_mobile,cpt_date_picker,cpt_calendar,cpt_date_picker_mobile,cpt_jumper,cpt_audio,
    cpt_chart_map_3d,cpt_chart_column_3d,cpt_time_run,cpt_indicator,cpt_chart_line_multiple,
    cpt_chart_line_dual,cpt_chart_map_3d_line,cpt_chart_pie_3d,cpt_quota_progress,
    cpt_link_card,cpt_img_state,cpt_navigator,cpt_scroll_list,cpt_water_prop,cpt_chart_rect_stack,
    cpt_chart_wordcloud,cpt_chart_line_3d,
    cpt_page,
    cpt_switch,
    cpt_phone,
    cpt_drawarea,
    cpt_realtime_position,
    cpt_display_trail,cpt_combination_page,
    cpt_choose_place,
    cpt_page,cpt_password,cpt_badge,cpt_map_navigator,cpt_amount,cpt_number,cpt_phone_number,cpt_scan,cpt_radio,cpt_time_picker,cpt_input_search,
    cpt_suspension,cpt_qrcode,cpt_textarea, cpt_iconfont, cpt_richtxt
 
    // cpt_tree_select
}
